/* Buy box v2 — comportamiento que no se puede resolver con Liquid ni CSS.
 *
 * 1. Selector de aumento: deja a la vista los 8 valores que concentran el 97%
 *    de las ventas (Neutro, +0.50, +1.00, +1.50, +2.00, +2.50, +3.00, +3.50) y
 *    pliega el resto en una fila que NOMBRA lo que esconde, para que quien
 *    necesita +1.75 lo vea y lo abra.
 * 2. Unifica el texto del botón entre el buy box y la barra fija.
 * 3. Barra fija visible desde que carga, salvo mientras el botón de la página
 *    está en pantalla (patrón de Meller e Izipizi).
 * 4. Marca el scroll para devolver el globo del chat a su lugar.
 *
 * No toca el flujo de compra: no cambia inputs, ni el form, ni los precios.
 */
(function () {
  'use strict';

  var TOP = ['neutro', '+0.50', '+1.00', '+1.50', '+2.00', '+2.50', '+3.00', '+3.50'];
  var TEXTO_BOTON = 'Agregar al carro';

  function norm(s) {
    return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function esTop(valor) {
    var v = norm(valor);
    if (v.indexOf('neutro') === 0) return true;
    return TOP.indexOf(v) !== -1;
  }

  /* 1 — aumento: 8 a la vista, el resto plegado */
  function plegarAumentos(scope) {
    var sets = scope.querySelectorAll('fieldset.variant-input-wrap');
    Array.prototype.forEach.call(sets, function (set) {
      var handle = set.getAttribute('data-handle') || '';
      if (handle.indexOf('aumento') === -1) return;
      if (set.hasAttribute('data-bb-aumento')) return;

      var inputs = set.querySelectorAll('.variant-input');
      if (inputs.length <= 9) {
        set.setAttribute('data-bb-aumento', '');
        return;
      }

      var extras = [];
      Array.prototype.forEach.call(inputs, function (el) {
        var valor = el.getAttribute('data-value') || '';
        var marcado = el.querySelector('input:checked');
        if (esTop(valor) || marcado) return;
        el.setAttribute('data-bb-extra', '');
        extras.push(valor.trim());
      });

      set.setAttribute('data-bb-aumento', '');
      if (!extras.length) return;

      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'bb-extra-toggle';
      boton.setAttribute('aria-expanded', 'false');
      boton.textContent = 'Otros: ' + extras.join(' · ');
      boton.addEventListener('click', function () {
        var abierto = set.hasAttribute('data-bb-abierto');
        if (abierto) {
          set.removeAttribute('data-bb-abierto');
          boton.setAttribute('aria-expanded', 'false');
          boton.textContent = 'Otros: ' + extras.join(' · ');
        } else {
          set.setAttribute('data-bb-abierto', '');
          boton.setAttribute('aria-expanded', 'true');
          boton.textContent = 'Ver menos aumentos';
        }
      });
      set.appendChild(boton);
    });
  }


  /* LensAdvisor dibuja su botón cuando termina de cargar, después de este script,
     y lo escribe en MAYÚSCULAS dentro de un nodo interno: no basta con CSS
     (text-transform no cambia texto que ya viene en mayúsculas) ni con una sola
     pasada. Se vigila el contenedor hasta que aparece. */
  function arreglarReceta(scope) {
    var pasar = function () {
      var receta = scope.querySelector('lensadvizor-btn, .la-select-lenses-btn');
      if (!receta) return false;
      var paseo = document.createTreeWalker(receta, NodeFilter.SHOW_TEXT, null);
      var nodo, cambio = false;
      while ((nodo = paseo.nextNode())) {
        if (/comprar con receta/i.test(nodo.nodeValue) && nodo.nodeValue.indexOf('Comprar con receta') === -1) {
          nodo.nodeValue = nodo.nodeValue.replace(/comprar con receta/i, 'Comprar con receta');
          cambio = true;
        }
      }
      return cambio;
    };
    pasar();
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function () { pasar(); });
    obs.observe(scope, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { obs.disconnect(); }, 15000);
  }


  /* 8 — H1 sin texto. Las fichas de ópticos traen un <h1> con un <strong> vacío
     (viene del contenido, no de este componente): para un lector de pantalla es
     un encabezado fantasma, y deja la página con dos H1. Se esconde, no se borra. */
  function ocultarH1Vacios(scope) {
    var h1s = document.querySelectorAll('#' + (scope.closest('[id^="shopify-section"]') || {}).id + ' h1');
    Array.prototype.forEach.call(h1s, function (h) {
      if (!(h.textContent || '').trim()) {
        h.hidden = true;
        h.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* 2 — un solo texto para la misma acción */
  function unificarBoton(scope) {
    var principal = scope.querySelector('.add-to-cart, [data-add-to-cart]');
    if (principal) {
      var txt = principal.querySelector('[data-add-to-cart-text]') || principal;
      if (norm(txt.textContent).indexOf('agotado') === -1 && norm(txt.textContent).indexOf('vendido') === -1) {
        txt.textContent = TEXTO_BOTON;
      }
    }
    arreglarReceta(scope);
    var fija = document.querySelectorAll('.bb-sticky-v4 [data-add-to-cart], .bb-sticky-v4 button[type="submit"], .bb-sticky-v4 .bb-sticky-v4__cta');
    Array.prototype.forEach.call(fija, function (b) {
      if (norm(b.textContent).indexOf('agotado') !== -1) return;
      if (b.children.length) return;
      b.textContent = TEXTO_BOTON;
    });
  }

  /* 3 — barra fija desde que carga, oculta mientras se ve el botón de la página */
  function barraDesdeElInicio(scope) {
    var barra = document.querySelector('.bb-sticky-v4');
    if (!barra) return;
    var principal = scope.querySelector('.add-to-cart, [data-add-to-cart]');
    var raiz = document.documentElement;
    raiz.classList.add('bb-cta-lejos');
    if (!principal || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        raiz.classList.toggle('bb-cta-lejos', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -72px 0px' });
    obs.observe(principal);
  }

  /* 4 — el chat vuelve a su lugar al bajar */
  function marcarScroll() {
    var marcar = function () {
      document.documentElement.classList.toggle('bb-scrolled', window.scrollY > 320);
    };
    marcar();
    window.addEventListener('scroll', marcar, { passive: true });
  }


  /* 5 — «Aumento» con ayuda para elegir. Guía orientativa, no diagnóstico. */
  var GUIA = [
    '<p><strong>Si ya usas lentes de lectura</strong>, elige el mismo aumento que tienes.</p>',
    '<p><strong>Si tienes receta</strong>, usa el valor de cerca (aparece como ADD o adición).</p>',
    '<p><strong>Si es tu primer par</strong>, como referencia: de 40 a 44 años suele bastar +1.00; de 45 a 49, +1.50; de 50 a 54, +2.00; de 55 a 59, +2.50; desde los 60, +3.00. Es una guía general, no un diagnóstico.</p>',
    '<p><strong>¿Entre dos aumentos?</strong> Elige el menor. Y si no acertaste, tienes 30 días para cambiarlo.</p>'
  ].join('');

  function ayudaAumento(scope) {
    var set = scope.querySelector('fieldset.variant-input-wrap[data-handle*="aumento"]');
    if (!set || set.hasAttribute('data-bb-ayuda')) return;
    var wrapper = set.closest('.variant-wrapper');
    var label = wrapper ? wrapper.querySelector('.variant__label') : null;
    if (!label) return;
    set.setAttribute('data-bb-ayuda', '');

    label.textContent = 'Aumento';
    var cab = document.createElement('div');
    cab.className = 'bb-aum-cab';
    label.parentNode.insertBefore(cab, label);
    cab.appendChild(label);

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'bb-aum-ayuda';
    boton.textContent = '¿Cuál necesito?';
    boton.setAttribute('aria-expanded', 'false');
    cab.appendChild(boton);

    var guia = document.createElement('div');
    guia.className = 'bb-aum-guia';
    guia.hidden = true;
    guia.innerHTML = GUIA;
    cab.parentNode.insertBefore(guia, cab.nextSibling);

    boton.addEventListener('click', function () {
      var abierta = !guia.hidden;
      guia.hidden = abierta;
      boton.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      boton.textContent = abierta ? '¿Cuál necesito?' : 'Cerrar la guía';
    });
  }

  /* 6 — galería: contador «1/8» en vez de una fila de puntos cuando hay más de cinco fotos */
  function contadorGaleria(scope) {
    var fotos = document.querySelector('.product__photos');
    var main = document.querySelector('.product__main-photos');
    var dots = fotos ? fotos.querySelector('.flickity-page-dots') : null;
    if (!fotos || !main || !dots) return;
    var puntos = dots.querySelectorAll('.dot');
    if (puntos.length <= 5) return;
    fotos.classList.add('bb-muchas-fotos');

    var contador = document.createElement('div');
    contador.className = 'bb-gal-contador';
    contador.setAttribute('aria-live', 'polite');
    main.appendChild(contador);

    var pintar = function () {
      var todos = dots.querySelectorAll('.dot');
      var i = 0;
      Array.prototype.forEach.call(todos, function (d, k) { if (d.classList.contains('is-selected')) i = k; });
      contador.textContent = (i + 1) + ' / ' + todos.length;
    };
    pintar();
    if ('MutationObserver' in window) {
      new MutationObserver(pintar).observe(dots, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }


  /* 7 — el resumen «Ahorras $X» del módulo reserva 44 px aunque no haya nada
     elegido; con espacios adentro, :empty no lo pilla. Se colapsa mientras no
     tenga texto y vuelve solo al elegir un 2.º par. */
  function colapsarResumen(scope) {
    var resumen = scope.querySelector('.bb-sp__summary');
    if (!resumen) return;
    var ahorro = resumen.querySelector('[data-bb-sp-summary]');
    if (!ahorro) return;
    // Se decide por el texto del ahorro, que el módulo escribe al elegir y vacía
    // al quitar. innerText engaña cuando el propio resumen está oculto.
    var pintar = function () { resumen.hidden = !(ahorro.textContent || '').trim(); };
    pintar();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { window.setTimeout(pintar, 0); })
        .observe(ahorro, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('bb:segundo-par', function () { window.setTimeout(pintar, 0); });
  }

  function arrancar() {
    var scope = document.querySelector('[data-bb-ficha-v2]');
    if (!scope) return;
    document.documentElement.classList.add('bb-v2');
    plegarAumentos(scope);
    ayudaAumento(scope);
    unificarBoton(scope);
    barraDesdeElInicio(scope);
    contadorGaleria(scope);
    colapsarResumen(scope);
    ocultarH1Vacios(scope);
    marcarScroll();

    // el theme redibuja el picker y reescribe el botón al cambiar de variante
    document.addEventListener('variantChange', function () {
      window.setTimeout(function () {
        plegarAumentos(scope);
        unificarBoton(scope);
      }, 0);
    }, true);

    var boton = scope.querySelector('.add-to-cart, [data-add-to-cart]');
    if (boton && 'MutationObserver' in window) {
      var reaplicando = false;
      new MutationObserver(function () {
        if (reaplicando) return;
        reaplicando = true;
        window.setTimeout(function () { unificarBoton(scope); reaplicando = false; }, 0);
      }).observe(boton, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/* Estrellas de la cabecera → reseñas (2-oct-2026). El enlace apuntaba a #bb-resenas, que no
   existe en la ficha, y el clic no hacía nada. Si algún día existe ese bloque, se baja hasta él;
   mientras tanto se abre el panel de opiniones de Growave por su SDK (vía soportada). Si el SDK
   no está, el enlace queda como estaba. */
(function () {
  document.addEventListener('click', function (e) {
    try {
      var a = e.target.closest ? e.target.closest('.bb-fh__estrellas') : null;
      if (!a) return;
      var destino = document.getElementById('bb-resenas');
      if (destino) { e.preventDefault(); destino.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var sdk = window.gw && window.gw.sdk;
      if (!sdk || typeof sdk.runIfModuleReady !== 'function') return;
      e.preventDefault();
      sdk.runIfModuleReady(sdk.common.constants.modules.REVIEWS, function () {
        try { sdk.reviews.methods.openReviewsDrawer(); } catch (err) {}
      });
    } catch (err) {}
  });
})();
